import React from "react";

import "../styles/about.scss";
import me from "../images/portfolio.jpg";
import HashLoader from "react-spinners/HashLoader";
import {
  BsDownload
} from "react-icons/bs";

export default function About() {
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return loading ? (
    <HashLoader
      className="loader"
      size={150}
      color={"#0a192f"}
      loading={loading}
    />
  ) : (
    <div className="about-page-container">
      <>
        <p className="about-bg">ABOUT</p>
        <h1 className="about-header">about me</h1>
        <div className="about-header-devider"></div>
      </>
      <div className="about-description-image">
        <p className="about-description">
      

Hello! 👋 I'm Sofoniyas, a **Full-Stack Developer** with **3+ years of professional experience** in building modern, responsive, and high-performance web and mobile applications. I specialize in turning ideas into fully functional digital products that are both visually appealing and highly scalable. My focus is on writing clean, maintainable code and delivering smooth user experiences across all devices.

I have strong experience working across the full development stack, from building dynamic frontend interfaces to developing robust backend systems and managing databases. I enjoy working with modern technologies and continuously improving my skills to stay up to date with industry trends. My goal is to create efficient, user-friendly, and impactful applications that solve real-world problems and exceed expectations.

<p>**Skills:** React • Next.js • TypeScript • React Native • Node.js • Express.js • MongoDB • PostgreSQL • JavaScript (ES6+) • HTML5 • CSS3 • Tailwind CSS • Bootstrap • Three.js • GraphQL • REST APIs • Firebase • Supabase • Appwrite • Python • WordPress • Git & GitHub
</p>
                 
                   
        </p>
        <img src={me} alt="mypic" />
      </div>
      <div className="about-buttons">
        <a
          href="https://drive.google.com/file/d/1hszCcHHGShTx_n1OFJq1wY-MT0GlZjY9/view?usp=sharing"
          target="blank"
          className="about-button-one"
        >
          <BsDownload style={{ color: "white" }} />
          download my CV
        </a>
      </div>
    </div>
  );
}
